module.exports = __webpack_public_path__ + "img/QR-999.833120c5.png";